import { Info } from 'lucide-react'
import { Tooltip } from '@/components/ui'

/**
 * Flags a cost figure that predates this product's earliest tracked
 * purchase order — it can only have drawn from pre-PO stock (e.g. an
 * "Initial Inventory Import" from a system migration), not a vendor
 * purchase. Surfaced after the SPI-5056 "$8.29/kg" investigation, where
 * a real, correct cost figure looked like a bug because it didn't match
 * any row in Odoo's Purchase History report (which only lists POs).
 */
export function CostProvenanceHint() {
  return (
    <Tooltip label="This order predates SPI's earliest tracked purchase order for this product — cost reflects initial inventory (e.g. a system migration), not a vendor PO.">
      <Info size={12} className="text-tertiary" aria-label="Cost predates earliest tracked purchase order" />
    </Tooltip>
  )
}
